// 4993 A5 — shift picker label (WIT-GAP-FLEX-4993-002 §7 A5).
//
// Legacy rule (unchanged): the bare name, with "(from → to +N)" only for a
// cross-midnight shift. Flex rule: always "name (from–to)", plus " +N" when
// the shift ends on a later day, so the employee sees the interval the
// overtime engine will measure against.

function clock (value) {
  return value === null || value === undefined ? '' : String(value).slice(0, 5)
}

export function shiftDisplayName (shift, flexHours = false) {
  if (!shift || !shift.name) return ''
  const offset = Number(shift.dayOffsetTo) || 0
  if (flexHours === true) {
    const from = clock(shift.timeFrom)
    const to = clock(shift.timeTo)
    const range = from && to ? `${from}–${to}` : ''
    const suffix = offset > 0 ? `+${offset}` : ''
    const inner = [range, suffix].filter(Boolean).join(' ')
    return inner ? `${shift.name} (${inner})` : shift.name
  }
  if (offset <= 0) return shift.name
  const range = shift.timeFrom && shift.timeTo ? `${shift.timeFrom} → ${shift.timeTo} ` : ''
  return `${shift.name} (${range}+${offset})`
}

export function withShiftDisplayName (shifts, flexHours = false) {
  if (!Array.isArray(shifts)) return []
  return shifts.map(s => ({ ...s, displayName: shiftDisplayName(s, flexHours) }))
}
